import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./PotItem.module.scss";
import { v4 } from "uuid";
import { CheckBox } from "@mui/icons-material";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ImageLoader from "../../comm/global/components/ImageLoader";
//showRadio -1 , 0 ,1
const PotItem = ({ data, index, showRadio, cb=()=>{} }) => {
    useEffect(() => {
        console.log("data data", data)
    }, [])
    return (
        <div className={style.item} onClick={e => {
            cb(index);
        }}>
            <div className={style.photo}>
                <ImageLoader src={(data.pocket_list_items_rewilding_detail.rewilding_photos?.length > 0) ? data.pocket_list_items_rewilding_detail.rewilding_photos[0].rewilding_photos_path : ''} />
            </div>
            <div className={style.info}>
                <div className={style.name}>
                    {data.pocket_list_items_name
                    }
                </div>
                <div className={style.desc}>
                    {data.pocket_list_items_rewilding_detail.rewilding_location ? data.pocket_list_items_rewilding_detail.rewilding_location.join(" ") : ""}
                </div>
            </div>
            {
                showRadio === 0 &&
                <RadioButtonUncheckedIcon />
            }
            {
                showRadio === 1 &&
                <RadioButtonCheckedIcon />
            }
        </div>
    );
}

export default PotItem;